import React from "react";

import { FormHelperText, FormLabel, MenuItem, Select } from "@mui/material";
import { useController } from "react-hook-form";

import { ReactComponent as ArrowDown } from "../../../Assets/Images/ArrowDown.svg";
import { FormItemsWrap } from "../../molecules/Wrap/Wrap";
import { Text } from "../Typography/Text/Text";
import Label from "./Label";

export const SelectInput = ({
  control,
  label,
  name,
  options,
  fullWidth,
  showSelectLabel,
  width,
  height,
  required,
  placeholder,
  size,
  disabled,
  fontSize,
  backgroundColor,
  showAllLabel = true,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });

  return (
    <FormItemsWrap>
      <Label label={label} required={required} />
      <Select
        disabled={disabled}
        style={{ fontSize: fontSize || "13px" }}
        IconComponent={ArrowDown}
        fullWidth={fullWidth}
        variant="outlined"
        displayEmpty
        error={fieldState?.invalid}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          width: width,
          borderRadius: "7px",
          backgroundColor: backgroundColor,
          ".MuiSelect-icon": {
            marginRight: "10px",
          },
        }}
        placeholder={placeholder}
        {...field}
      >
        {showSelectLabel && showAllLabel && (
          <MenuItem key={Math.random() * 10} value="">
            <span
              style={{
                color: "#9F9F9F",
              }}
            >
              {field?.value && showAllLabel ? "All" : placeholder}
            </span>
          </MenuItem>
        )}

        {Array.isArray(options) &&
          options?.length > 0 &&
          options.map((item) => {
            return (
              <MenuItem
                key={item?.key}
                value={item?.key}
                style={{ fontSize: fontSize || "13px" }}
              >
                {item?.label}
              </MenuItem>
            );
          })}
      </Select>
      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};

export const SelectInputType2 = ({
  control,
  label,
  name,
  color,
  options,
  fullWidth,
  placeholder,
  showSelectLabel,
  width,
  height,
}) => {
  const { field, fieldState } = useController({
    control: control,
    name: name,
  });
  return (
    <FormItemsWrap>
      <FormLabel component="legend">
        <Text text={label} color={color} />
      </FormLabel>
      <Select
        IconComponent={() => (
          <ArrowDown
            style={{
              marginRight: "11px",
            }}
          />
        )}
        fullWidth={fullWidth}
        variant="outlined"
        defaultValue={options[0]?.key}
        displayEmpty
        error={fieldState?.invalid}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre",
          width: width,
          height: height ? height : "100%",
          borderRadius: "7px",
        }}
        {...field}
      >
        {showSelectLabel && (
          <MenuItem key={Math.random() * 10} value="">
            <span
              style={{
                color: "#9F9F9F",
              }}
            >
              {field?.value ? "All" : placeholder}
            </span>
          </MenuItem>
        )}

        {Array.isArray(options) &&
          options?.length > 0 &&
          options.map((item) => {
            return (
              <MenuItem key={item?.key} value={item?.key}>
                {item?.label}
              </MenuItem>
            );
          })}
      </Select>
      {fieldState?.error?.message && (
        <FormHelperText style={{ color: "red" }}>
          {fieldState?.error?.message}
        </FormHelperText>
      )}
    </FormItemsWrap>
  );
};
